import React from 'react';
import { useLocation } from 'react-router-dom';
import ProductCompatScreen, { type ProductCompatInput } from '../screens/ProductCompatScreen';
import { mergeProductPairs, readProductPairFromSearch, type ProductPairTransfer } from '../utils/productIdentity';

type NavState = Partial<ProductPairTransfer> & {
  prefill?: ProductCompatInput['prefill'];
  usage?: ProductCompatInput['usage'];
  pendingSide?: ProductCompatInput['pendingSide'];
};

export default function ProductCompatibilityScanPage(): React.JSX.Element {
  const location = useLocation();
  const state = (location.state ?? {}) as NavState;
  const products = mergeProductPairs(state.products, readProductPairFromSearch(location.search));
  return <ProductCompatScreen mode="page" input={{ products, prefill: state.prefill, usage: state.usage, pendingSide: state.pendingSide }} />;
}
